import styled, { css } from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { ImageStyledWrapper } from '@yme/atoms/image';
import { MiniButton } from '@yme/atoms/mini-button';
import { HEADER_HEIGHT } from '@yme/common/constants';
import { Link } from '@yme/components/Link';
import { colorCoreBlack900Base, colorCoreGray300, colorCoreGray500, colorCoreWhite1000, colorAccentLinkLight, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
import { SEARCH_INPUT_HEIGHT } from './constants';
const mobileSearchWrapper = css `
  width: 100%;
  padding: 16px;
`;
export const SearchContainerStyled = styled.div `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const SearchWrapperStyled = styled(FlexWrapper) `
  position: relative;
  width: 100%;
`;
export const SearchHistoryWrapperStyled = styled(FlexWrapper) `
  position: absolute;
  top: calc(100% + 7px);
  width: 100%;
  z-index: ${Z_INDEX.level2};

  background-color: ${colorCoreWhite1000};
  border: 1px solid ${colorCoreGray300};
  border-radius: ${CORNER_RADIUS.m};
  box-shadow: ${elevationBottomLvl2};
`;
export const SearchInputWrapperStyled = styled.div `
  position: relative;

  ${({ isFullWidth }) => (isFullWidth ? mobileSearchWrapper : 'width: 100%;')};
`;
export const SearchListStyled = styled.ul `
  width: 100%;
  padding: 6px 0 6px 6px;
  margin: 0;
  list-style: none;
  box-sizing: border-box;

  ${CustomScroll};

  overscroll-behavior: contain;
  border-left: none;
  border-bottom: none;
  border-top: 1px solid ${colorCoreGray300};

  max-height: ${({ isSearchPage }) => isSearchPage ? '600px' : `calc(100dvh - ${HEADER_HEIGHT.sm} - ${SEARCH_INPUT_HEIGHT})`};

  ${ADAPTIVE.minWidth.tablet} {
    max-height: ${({ isSearchPage }) => isSearchPage ? '600px' : `calc(100dvh - ${HEADER_HEIGHT.md} - ${SEARCH_INPUT_HEIGHT})`};
  }

  ${ADAPTIVE.minWidth.desktop} {
    height: auto;
    max-height: 600px;
  }

  ${({ isSearchHistory }) => isSearchHistory &&
    css `
      border-top: none;
      padding: 0;
    `};
`;
export const SearchItemStyled = styled.li `
  width: 100%;
  position: relative;

  ${getTextStyles('Ubuntu', null, 14, 20)}

  ${({ isActive }) => isActive && `background-color: ${colorCoreGray300}`};

  &::before {
    content: '';
    position: absolute;
    left: 0;
    height: 100%;
    width: 6px;
    border-radius: 3px;

    ${({ isActive }) => isActive && `background-color: ${colorAccentLinkLight}`};
  }

  &:hover {
    background-color: ${colorCoreGray300};
  }
`;
export const UnitInfoStyled = styled.div `
  width: 100%;
`;
const commonLinkStyles = css `
  box-sizing: border-box;
  display: flex;
  padding: ${({ $isProductItem }) => ($isProductItem ? '8px' : '10px 12px 10px 10px')};
  width: 100%;
  gap: ${({ $isProductItem }) => ($isProductItem ? `${INDENT.xxs}` : `${INDENT.xxxs}`)};
  align-items: center;
  text-decoration: none;
  color: ${colorCoreBlack900Base};

  ${ADAPTIVE.minWidth.desktop} {
    padding: 8px;
  }
`;
export const LinkWrapperStyled = styled(Link) `
  ${commonLinkStyles};

  ${ImageStyledWrapper} {
    flex-shrink: 0;
    background-color: ${colorCoreWhite1000};
  }

  ${({ hasBackground }) => hasBackground &&
    css `
      &:hover {
        background-color: ${colorCoreGray300};
      }
    `};
`;
export const LinkHistoryWrapperStyled = styled(Link) `
  ${commonLinkStyles};

  padding-right: 2px;
  justify-content: space-between;

  ${ADAPTIVE.minWidth.desktop} {
    padding-right: 2px;
  }
`;
export const InputWrapperStyled = styled.div `
  position: relative;
`;
export const BackButtonStyled = styled(MiniButton) `
  position: absolute;
  top: calc(50% - 10px);
  padding-top: 0;
  padding-bottom: 0;
`;
export const HiddenButtonStyled = styled.span `
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: transparent;
`;
export const CloseButtonStyled = styled(MiniButton) `
  position: absolute;
  height: 100%;
  padding: 8px 16px;

  ${({ isRightToLeft }) => isRightToLeft ? 'right: calc(100% + 16px)' : 'left: calc(100% + 16px)'};
`;
export const SeparatorStyled = styled.div `
  height: 1px;
  margin-top: ${INDENT.xxxxs};
  margin-bottom: ${INDENT.xxxxs};

  background-color: ${colorCoreGray500};
`;
export const ImageWrapperStyled = styled.div `
  width: 48px;
  height: 48px;
`;
export const DidYouMeanWrapperStyled = styled.div `
  width: 100%;
  padding: 6px;
  border-top: 1px solid ${colorCoreGray300};

  ${ADAPTIVE.minWidth.desktop} {
    border-top: none;
  }
`;
export const SearchHistoryContentStyled = styled(FlexWrapper) `
  border-top: 1px solid ${colorCoreGray300};
`;
export const SearchHintStyled = styled(RegularTextLevel4) `
  padding: 12px 16px;

  ${ADAPTIVE.minWidth.desktop} {
    padding: 10px 12px;
  }
`;
export const DividerStyled = styled.div `
  height: 1px;
  background-color: ${colorCoreGray500};
  margin: 4px 12px;
`;
